import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const btn = this.el;
		const p1 = btn.querySelector('#p1');
		const p2 = btn.querySelector('#p2');

		// Panel references
		const panel = document.getElementById(btn.getAttribute('aria-controls')) || document.getElementById('searchBox');
		const panelContent = panel.querySelector('.search-content') || panel;
		const input = panel.querySelector('input');

		const searchShape = {
			s1: "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",
			s2: "M21 21L16.65 16.65"
		};

		const closeShape = {
			s1: "M18.5 5.5L5.5 18.5",
			s2: "M5.5 5.5L18.5 18.5"
		};

		function isOpen() {
			return btn.getAttribute('aria-expanded') === 'true';
		}

		function setOpenState(open) {
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.setAttribute('aria-hidden', open ? 'false' : 'true');

			if (open) {
				// Open animations
				gsap.to(p1, { attr: { d: closeShape.s1 }, duration: 0.4, ease: 'back.out(1.7)' });
				gsap.to(p2, { attr: { d: closeShape.s2 }, duration: 0.4, ease: 'back.out(1.7)' });
				gsap.to(panel, { height: 150, duration: 0.5, ease: 'power3.out' });
				gsap.to(panelContent, { opacity: 1, y: 0, duration: 0.4, delay: 0.1 });
				setTimeout(() => input && input.focus(), 300);
			} else {
				// Close animations
				gsap.to(p1, { attr: { d: searchShape.s1 }, duration: 0.4, ease: 'power2.inOut' });
				gsap.to(p2, { attr: { d: searchShape.s2 }, duration: 0.4, ease: 'power2.inOut' });
				gsap.to(panel, { height: 0, duration: 0.4, ease: 'power3.inOut' });
				gsap.to(panelContent, { opacity: 0, y: 20, duration: 0.2 });
			}
		}

		function toggleSearch() {
			setOpenState(!isOpen());
		}

		function onClick(e) {
			// If there's an open mobile nav button, close it first to avoid two 'close' buttons in header
			const openMobile = document.querySelector('.mobile-nav-button[aria-expanded="true"]');
			if (openMobile) {
				// trigger its click (its module should handle proper closing)
				openMobile.click();
				// wait a bit for the menu to close before toggling search
				setTimeout(() => toggleSearch(), 180);
				return;
			}
			// otherwise just toggle
			toggleSearch();
		}

		btn.addEventListener('click', onClick);

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && isOpen()) toggleSearch();
		});

		// Allow other modules to request the search panel to close via a custom event
		document.addEventListener('search:close', () => {
			if (isOpen()) {
				setOpenState(false);
			}
		});

		// Emit events when animations complete so other modules can synchronize
		// Dispatch 'search:opened' after open animation completes
		// and 'search:closed' after close animation completes
		const origSetOpenState = setOpenState;
		// Replace setOpenState behaviour to dispatch events onComplete
		function setOpenStateWithEvent(open) {
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.setAttribute('aria-hidden', open ? 'false' : 'true');

			if (open) {
				// Open animations
				gsap.to(p1, { attr: { d: closeShape.s1 }, duration: 0.4, ease: 'back.out(1.7)' });
				gsap.to(p2, { attr: { d: closeShape.s2 }, duration: 0.4, ease: 'back.out(1.7)' });
				/* gsap.to(panel, { height: 150, duration: 0.5, ease: 'power3.out', onComplete: () => {
					document.dispatchEvent(new CustomEvent('search:opened'));
				} });
				gsap.to(panelContent, { opacity: 1, y: 0, duration: 0.4, delay: 0.1 });
				setTimeout(() => input && input.focus(), 300); */
			} else {
				// Close animations
				gsap.to(p1, { attr: { d: searchShape.s1 }, duration: 0.4, ease: 'power2.inOut' });
				gsap.to(p2, { attr: { d: searchShape.s2 }, duration: 0.4, ease: 'power2.inOut' });
				/* gsap.to(panel, { height: 0, duration: 0.4, ease: 'power3.inOut', onComplete: () => {
					document.dispatchEvent(new CustomEvent('search:closed'));
				} }); */
				/* gsap.to(panelContent, { opacity: 0, y: 20, duration: 0.2 }); */
			}
		}

		// Override the original helper so rest of module uses newer version
		window.__search_setOpenState = setOpenStateWithEvent;
		// Use the new function internally
		function setOpenState(open) { setOpenStateWithEvent(open); }
	}
}

